var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationCity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.2915V6.12148C15 5.59148 14.79 5.08148 14.41 4.71148L12.7 3.00148C12.31 2.61148 11.68 2.61148 11.29 3.00148L9.59 4.70148C9.21 5.08148 9 5.59148 9 6.12148V7.29148H5C3.9 7.29148 3 8.19148 3 9.29148V19.2915C3 20.3915 3.9 21.2915 5 21.2915H19C20.1 21.2915 21 20.3915 21 19.2915V13.2915C21 12.1915 20.1 11.2915 19 11.2915H15ZM7 19.2915H5V17.2915H7V19.2915ZM7 15.2915H5V13.2915H7V15.2915ZM7 11.2915H5V9.29148H7V11.2915ZM13 19.2915H11V17.2915H13V19.2915ZM13 15.2915H11V13.2915H13V15.2915ZM13 11.2915H11V9.29148H13V11.2915ZM13 7.29148H11V5.29148H13V7.29148ZM19 19.2915H17V17.2915H19V19.2915ZM19 15.2915H17V13.2915H19V15.2915Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCity);
export default __webpack_public_path__ + "static/media/LocationCity.df6dd7b7622fe4099eada1f48fe79d70.svg";
export { ForwardRef as ReactComponent };